export const px2rem = (size, defaultWidth = 1920) => {
  const clientWidth =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
  if (!clientWidth) return size;
  if (clientWidth > defaultWidth) {
    return size;
  }
  const scale = clientWidth / defaultWidth;
  return Number((size * scale).toFixed(3));
};
